const Pact = require("../../entities/Pact");
const {Age}  = require("../Constants");
const PactNames = require("../Names/PactNames");


class PeaceTreaty extends Pact {
    constructor() {
        super(
            Age.Age3,
            PactNames.PeaceTreaty,
            "The two civilizations cannot attack each other. Each civilization produces 1 extra culture.",
            {}
        )
    }
}

module.exports = PeaceTreaty;